<template>
  <div class="carousel banner-carousel" v-if="has_slides">
    <swiper class="swiper" :options="swiperOption" ref="carousel" :instanceName="'banner-slider'">
      <swiper-slide v-for="(slide,i) in slides" :key="`slide-${i}`" class="banner-slide">
        <template v-if="!isEmpty(slide.redirect)">
          <template v-if="slide.redirect.external">
            <a :href="slide.redirect.to" target="_blank">
              <img :src="slide.image" v-if="slide.image" class="carousel-image" @load="imgLoaded"/>
            </a>
          </template>
          <template v-else>
            <router-link :to="slide.redirect.to">
              <img :src="slide.image" v-if="slide.image" class="carousel-image" @load="imgLoaded"/>
            </router-link>
          </template>
        </template>
        <template v-else>
          <img :src="slide.image" v-if="slide.image" class="carousel-image" @load="imgLoaded"/>
        </template>
      </swiper-slide>
    </swiper>
    <div class="carousel-pagination" slot="pagination"></div>
    <div class="swiper-button-prev banner-slider-prev" slot="button-prev"></div>
    <div class="swiper-button-next banner-slider-next" slot="button-next"></div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import {mapGetters} from 'vuex'

  export default {
    name: 'BannerSlider',
    props: ['data'],
    data() {
      return {
        loading: false,
        slides: [],
        swiperOption: {
          loop: true,
          initialSlide: 0,
          spaceBetween: 8,
          autoHeight: true,
          pagination: {
            el: '.carousel-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.banner-slider-next',
            prevEl: '.banner-slider-prev'
          }
        }
      }
    },
    computed: {
      ...mapGetters(['bannerSlides']),
      has_slides() {
        return !_.isEmpty(this.slides)
      }
    },
    async mounted() {
      let key = _.get(this.data, 'collectionKey')
      await this.$store.dispatch('fetchBannerSlides', {once: true, key});
      let slides = _.get(this.bannerSlides, 'slides', []);

      if (!_.isEmpty(slides)) {
        this.slides = slides;
        this.setNotificationAction();
      }

      this.banner_data = _.get(this.bannerSlides, 'dimensions', false);
    },
    methods: {
      imgLoaded() {
        this.$refs['carousel'].updateSwiper();
      },
      setNotificationAction() {
        this.slides.forEach((slide) => {
          let action = _.get(slide, 'action');
          if (!action) {
            return
          }

          const openType = _.get(action, 'open_type');
          const bountyId = _.get(action, 'reward_id');
          // const shop = {value: _.get(action, 'shop_id')};
          const url = _.get(action, 'url');

          let redirect;

          switch (openType) {
            case 'reward_details':
            case 'sweepstake_details':
              redirect = {
                to: {name: "reward-details", params: {id: bountyId}}
              }
              break;
            // TODO: enable when shop-extension is added
            // case 'location_details':
            //   redirect = {
            //     to: {name: "reward-details", params: {id: bountyId}}
            //   }
            //   break;
            case 'web_view':
              redirect = {
                external: true,
                to: url
              }
              break;
            default:
              redirect = {};
          }

          slide.redirect = redirect;
        });
      },
      isEmpty(arr) {
        return _.isEmpty(arr)
      }
    },
  }
</script>

<style lang="scss" scoped>
  .carousel {
    margin: 0 auto 80px;
  }
  @media(max-width: 768px) {
    .carousel {
      width: calc(100% - 20px);
    }
  }

  .carousel-image {
    width: 100%;
    height: auto;
  }

  .banner-carousel {
    .swiper {
      width: 100%;
      height: auto;
      left: 0px;
      padding: 0;
    }
  }

  .carousel-pagination {
    display: flex;
    margin-top: 20px;
    justify-content: center;
  }

  @media(max-width: 768px) {
    .banner-carousel .swiper-button-prev {
      left: -20px;
    }
    .banner-carousel .swiper-button-next {
      right: -20px;
    }
  }

  .banner-slide a {
    display: block;
  }
</style>
